module.exports = __webpack_public_path__ + "img/attention-icon.0f170216.svg";